module.exports = __webpack_public_path__ + "static/media/api-icon.3ed3ff0d.svg";